import { View, Button, Dialog } from "../base";
import { WebhookSettingsForm, WebhookSettingsFormData } from "./WebhookSettingsForm";

type WebhookSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: WebhookSettingsFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const WebhookSettingsDialog = ({ isOpen, onClose, config, onChange }: WebhookSettingsDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Webhook Settings"
      size="flex"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      <View className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
        <WebhookSettingsForm
          config={config}
          onChange={onChange}
        />
      </View>
    </Dialog>
  );
};
